import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "flex-center flex-col"
};
const _hoisted_2 = {
  class: "col-span-3 grow flex flex-col justify-center items-end h-full"
};
const _hoisted_3 = {
  class: "text-slate-600"
};
const _hoisted_4 = {
  class: "flex justify-end items-center"
};
const _hoisted_5 = {
  class: "py-1 px-3 bg-slate-100 text-slate-600 font-bold"
};
import ActionLayout from "@/modules/base/layouts/ActionLayout.vue";
import { Season } from "@/modules/season/entity";
import { Team } from "@/modules/team/entity";
import { Match } from "@/modules/match/entity";
import { app } from "@/di";
import LineupSkillCalculator from "@/modules/team/services/LineupSkillCalculator";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import LineupValidator from "@/modules/team/services/LineupValidator";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import Icon from "@/modules/vue/components/Icon.vue";
import { EventEmitter } from "@/modules/base/events";
import { AfterLineupChangedEndEvent } from "@/modules/team/events/AfterLineupChangedEndEvent";
export default /*#__PURE__*/_defineComponent({
  __name: 'BeforeMatchLayout',
  props: {
    hideActionBar: {
      type: Boolean
    },
    hideTabbar: {
      type: Boolean
    },
    contentClasses: null
  },
  async setup(__props, {
    expose
  }) {
    let __temp, __restore;
    const props = __props;
    const router = useRouter();
    const team = ref();
    const oppositeTeam = ref();
    const nextMatch = ref();
    const lineupSkill = ref();
    const lineupOppositeSkill = ref();
    const lineupValidation = ref();
    const lineupSkillCalculator = app.get(LineupSkillCalculator);
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      team.value = await Team.createQueryBuilder('team').innerJoinAndSelect('team.players', 'player').leftJoinAndSelect('player.suspensions', 'suspensions').where('team.user = true').getOneOrFail();
      nextMatch.value = await Match.findNext(await Season.current(), team.value);
      oppositeTeam.value = nextMatch.value.homeTeam.user ? nextMatch.value.awayTeam : nextMatch.value.homeTeam;
      await oppositeTeam.value.load('players');
      lineupSkill.value = lineupSkillCalculator.calculateLinedupSkillByTeam(team.value);
      lineupOppositeSkill.value = lineupSkillCalculator.calculateLinedupSkillByTeam(oppositeTeam.value);
      lineupValidation.value = await app.get(LineupValidator).validate(team.value, nextMatch.value);
    })), __temp = await __temp, __restore(), __temp);
    onBeforeUnmount(app.get(EventEmitter).onOff([AfterLineupChangedEndEvent], refresh));
    const actionIconColor = computed(() => ({
      'warning': ColorEnum.Amber,
      'error': ColorEnum.Red,
      'success': ColorEnum.Green
    })[lineupValidation.value.type]);
    const lineupValidationDialog = ref(null);
    const onClickAction = async () => {
      if (lineupValidation.value.type === 'error') {
        lineupValidationDialog.value.show();
        return;
      }
      if (lineupValidation.value.type === 'warning') {
        await lineupValidationDialog.value.confirm();
      }
      router.push({
        name: 'matches.evaluation.before',
        params: {
          id: nextMatch.value.id
        },
        query: {
          start: true
        }
      });
    };
    expose({
      refresh
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(ActionLayout, _mergeProps(_ctx.$attrs, {
        position: "end",
        "action-icon": _ctx.IconEnum.PlayCircle,
        "action-color": _unref(actionIconColor),
        onClickAction: onClickAction
      }), _createSlots({
        actionPanel: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(nextMatch.value.matchday.division.competition.name) + " | ", 1), _createElementVNode("span", _hoisted_3, _toDisplayString(nextMatch.value.matchday.division.name), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(EntityLink, {
          entity: oppositeTeam.value,
          class: "mr-2"
        }, null, 8, ["entity"]), _createElementVNode("div", _hoisted_5, _toDisplayString(lineupOppositeSkill.value), 1)])])]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default"), lineupValidation.value.message ? (_openBlock(), _createBlock(RichDialog, {
          key: 0,
          ref_key: "lineupValidationDialog",
          ref: lineupValidationDialog,
          "show-ok-only": lineupValidation.value.type === 'error',
          "confirmation-text": _ctx.$t('start_match')
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('lineup')), 1)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [lineupValidation.value.type === 'error' ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            icon: _ctx.IconEnum.ErrorCircle16Regular,
            size: "6rem",
            class: "text-red-400 mb-4"
          }, null, 8, ["icon"])) : lineupValidation.value.type === 'warning' ? (_openBlock(), _createBlock(Icon, {
            key: 1,
            icon: _ctx.IconEnum.ErrorCircle16Regular,
            size: "6rem",
            class: "text-amber-400 mb-4"
          }, null, 8, ["icon"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(lineupValidation.value.message), 1)])]),
          _: 1
        }, 8, ["show-ok-only", "confirmation-text"])) : _createCommentVNode("", true)]),
        _: 2
      }, [_ctx.$slots.title ? {
        name: "title",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "title")])
      } : undefined, _ctx.$slots.subtitle ? {
        name: "subtitle",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "subtitle")])
      } : undefined]), 1040, ["action-icon", "action-color"]);
    };
  }
});